import { Request } from 'commons/utils/request/request'

export const getCompanyDetailsWebPage = (relationshipId: number) =>
  Request.post(Request.urls.bank.companyDetailsWebpage, { relationshipId })

export type FilterCompanyCustomersWebPage = {
  relationshipId?: number | undefined
  page: number
  size: number
  customersName?: string | undefined
}

export const getCompanyCustomersWebPage = (filter: FilterCompanyCustomersWebPage) =>
  Request.post(Request.urls.bank.companyCustomersWebpage, { ...filter })

export type FilterCompanyVendorsWebPage = {
  relationshipId?: number | undefined
  page?: number | undefined
  size?: number | undefined
  vendorsName?: string | undefined
}

export const getCompanyVendorsWebPage = (filter: FilterCompanyVendorsWebPage) =>
  Request.post(Request.urls.bank.companyVendorsWebpage, { ...filter })

export type FilterCompanyContactsWebPage = {
  relationshipId?: number | undefined
  page: number
  size: number
  contactsType?: string | undefined
}

export const getCompanyContactsWebPage = (filter: FilterCompanyContactsWebPage) =>
  Request.post(Request.urls.bank.companyContactsWebpage, { ...filter })

export type FilterCompanyHistoryWebPage = {
  relationshipId: number | undefined
  page: number | undefined
  size: number | undefined
}

export const getCompanyDetailsHistoryWebPage = (filter: FilterCompanyHistoryWebPage) =>
  Request.post(Request.urls.bank.companyHistoryDetailsWebpage, { ...filter })

export type FilterCompanyAdverseMediaWebPage = {
  relationshipId?: number | undefined
  page?: number | undefined
  size?: number | undefined
}

export const getCompanyAdverseMediaWebPage = (filter: FilterCompanyAdverseMediaWebPage) =>
  Request.post(Request.urls.bank.companyAdverseMediaWebpage, { ...filter })

export type FilterCompanyDocumentsWebPage = {
  alerts?: string
  bankAccountId?: number
  contactId?: number
  frequency?: string
  isInternal?: boolean | null
  licenseId?: number
  page: number
  size: number
  relationshipId?: number
  sortBy?: string
  sortDesc?: boolean
  subjectType?: string
}

export const getCompanyDocumentsWebPage = (filter: FilterCompanyDocumentsWebPage) =>
  Request.post(Request.urls.bank.companyDocumentsWebpage, { ...filter })

export type FilterCompanyQuarterlyAnalyticsWebPage = {
  relationshipId: number | undefined
  page: number | undefined
  size: number | undefined
}

export type FilterCompanyAffiliatedCompaniesWebPage = {
  relationshipId: number | undefined
  page?: number | undefined
  size?: number | undefined
}

export const getCompanyAffiliatedCompaniesWebPage = (filter: FilterCompanyAffiliatedCompaniesWebPage) =>
  Request.post(Request.urls.bank.companyAffiliatedCompaniesWebpage, { ...filter })

export type FilterCompanyLicensesWebPage = {
  relationshipId: number | undefined
  page?: number | undefined
  size?: number | undefined
}

export const getCompanyLicensesWebPage = (filter: FilterCompanyLicensesWebPage) =>
  Request.post(Request.urls.bank.companyLicensesWebpage, { ...filter })

export type FilterCompanyBankAccountsWebPage = {
  relationshipId: number | undefined
  page?: number | undefined
  size?: number | undefined
}

export const getCompanyBankAccountsWebPage = (filter: FilterCompanyBankAccountsWebPage) =>
  Request.post(Request.urls.bank.companyBankAccountsWebpage, { ...filter })

export type FilterCompanyAnnualReviewWebPage = {
  relationshipId: number | undefined
  page?: number | undefined
  size?: number | undefined
}

export const getCompanyAnnualReviewWebPage = (filter: FilterCompanyAnnualReviewWebPage) =>
  Request.post(Request.urls.bank.companyAnnualReviewsWebpage, { ...filter })
